import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { PromotionCode } from './promotion-code.model';
import { PromotionCodeService } from './promotion-code.service';

@Injectable()
export class PromotionCodeResolver implements Resolve<PromotionCode> {
  constructor(private promotionCodeService: PromotionCodeService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PromotionCode> {
    return this.promotionCodeService.getById(route.paramMap.get('promotionCodeId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/promotion-codes/promotion-code.resolver.ts